import React from "react";
import { Link } from "react-router-dom";
import "./Footer.css";

export default function Footer() {
  return (
    <footer className="site-foot">
      <div className="site-foot-inner">
        <div className="site-foot-brand">
          <span className="foot-brand">FOLIOX</span>
        </div>

        <nav className="site-foot-links" aria-label="Footer">
          <Link to="/">Generator</Link>
          <Link to="/pricing">Pricing</Link>
          <Link to="/support">Support</Link>
          <Link to="/about">About</Link>
          <Link to="/about#terms">Terms</Link>
          <Link to="/about#privacy">Privacy</Link>
        </nav>
      </div>
    </footer>
  );
}
